
import React from 'react'

import { ArrowLeftOutlined, PlusOutlined, SyncOutlined } from '@ant-design/icons'
import { Alert, Button, Col, Divider, Drawer, Form, Input, Modal, Row, Select, Space, Table, Typography } from 'antd'
import { Link, useParams } from 'react-router-dom'

import { usePreguntasMaterias } from '../../hooks/adminexamen/usePreguntasMaterias'
import { Toaster } from 'react-hot-toast'
import { EmptyPersonalizado } from '../../components/EmptyPersonalizado'
import { useMaterias } from '../../hooks/adminexamen/useMaterias'

import '../../css/list.css'
import { DragDropContext } from 'react-beautiful-dnd'
import { Droppable } from 'react-beautiful-dnd'
import { Draggable } from 'react-beautiful-dnd'
import { reorder } from '../../functions/arreglos'
import { alias_examen } from '../../data/datos'
import { DOMINIO_SERVIDOR } from '../../api/url'
import { sin_editar } from '../../data/datos'
import { useLoginStore } from '../../stores/useLoginStore'

// ant-input
const { Title } = Typography;
const { Option } = Select;

const PreguntasMaterias = () => {

    const { id:pk_materia } = useParams('id')

    const { materias } = useMaterias()
    const { email } = useLoginStore( store => store.objLogueado )
    let mostrarBtn = !sin_editar.includes( email )
    // console.log(mostrarBtn);

    const { visible, setVisible, onChange, borrarImagen, setPregunta,
        guardarPregunta, setCorrecto, administrarRespuestas,
        columns, preguntasDeMateria, activeExpRow, setActiveExpRow,
        respuestasPregunta, setRespuestasPregunta, reordenarRespuestas,
        visibleModal, setVisibleModal, loadingModal, copiar, setMateriaSeleccionada,
        limpiarFormulario, form, setFuncion, isLoading, loading } = usePreguntasMaterias( mostrarBtn )

    return (

        <>
            <Link to='/materias' style={{
                marginRight: 50
            }}>
                <Button type="primary" shape="round" icon={<ArrowLeftOutlined />} size="middle">
                    Materias
                </Button>
            </Link>

            { mostrarBtn && (
                <Button type="primary" shape="round" icon={<PlusOutlined />} size="middle" onClick={ () => {
                    setVisible( true )
                    setFuncion( 'guardarPregunta' )
                }}>
                    Pregunta
                </Button>
            )}

            <div
                style={{
                    paddingTop: '20px'
                }}
            >
                {/* el menú drawer claro que si */}
                <Drawer
                    maskClosable={ false }
                    title="Agregar nueva pregunta"
                    width={ 720 }
                    onClose={ () => { setVisible( false ); limpiarFormulario() }}
                    visible={ visible }
                    bodyStyle={{ paddingBottom: 80 }}
                    extra={
                        <Space>
                            <Button onClick={ () => { limpiarFormulario() }}>Limpiar</Button>
                            <Button onClick={ () => guardarPregunta() } type="primary" loading={ isLoading }>
                                Guardar
                            </Button>
                        </Space>
                    }
                >
                    <Form
                        form={ form }
                    >
                        <Row gutter={ 16 }>

                            {/* pregunta */}
                            <Col span={ 24 }>
                                <Form.Item
                                    name="pregunta"
                                    label="Pregunta:"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Debes añadir un enunciado.',
                                        },
                                    ]}
                                >
                                    <Input.TextArea id='textareaPregunta' rows={ 4 } placeholder="Descripción de la pregunta" onChange={ e => setPregunta( e.target.value ) }/>
                                </Form.Item>
                            </Col>

                            {/* imagen */}
                            <Col span={ 24 }>
                                <label>Imagen (opcional)</label>
                                <input id='inputFile' type='file' onChange={ onChange } accept='image/*'/>
                                <div style={{ display: 'flex' }}>
                                    <img id='imgPrueba' style={{
                                        maxHeight: 200
                                    }}/>
                                    <Button onClick={ borrarImagen } style={{
                                        marginTop: 20
                                    }}
                                    type='dashed'
                                    >
                                        Borrar imagen
                                    </Button>
                                </div>
                            </Col>

                            {/* opciones */}
                            <Title level={ 4 } style={{ width: '100%', textAlign: 'center' }}>Respuestas</Title>
                            { [1, 2, 3, 4, 5].map( elem => (
                                <Col key={ elem } span={ 24 }>
                                    <Divider/>
                                    {/* <Checkbox onChange={ (e) => setCorrecto( e.target.checked, elem ) }>Marcar como correcta</Checkbox> */}
                                    <input
                                        type="radio"
                                        id={`Respuesta${elem}`}
                                        name="fav_language"
                                        value={`Respuesta${elem}`}
                                        onChange={ (e) => setCorrecto( elem ) }
                                    />
                                    <label htmlFor={`Respuesta${elem}`}> Marcar como correcta </label><br></br>
                                    <Form.Item
                                        name={ 'respuesta'+elem }
                                        label={ `Respuesta ${elem}:` }
                                        style={{ marginTop: 10 }}
                                    >
                                        <Input.TextArea id='textareaRespuesta' rows={ 2 } placeholder="Descripción de la Respuesta" onChange={ e => administrarRespuestas( elem, e.target.value ) }/>
                                    </Form.Item>
                                </Col>
                            ))}


                        </Row>
                    </Form>
                </Drawer>

                {/* la tabla claro que si */}
                <Table
                    loading={ loading }
                    columns={ columns }
                    dataSource={ preguntasDeMateria }
                    locale={{ emptyText: <EmptyPersonalizado/> }}
                    rowKey="pk_preguntas"
                    showSorterTooltip={ false }
                    expandable={{
                        expandedRowRender: record => (
                            <>
                                { mostrarBtn && (
                                    <div style={{ display: 'flex'}}>
                                        <Alert message="Puedes arrastrar las respuestas para reordenarlas" type="info" showIcon closable/>
                                    </div>
                                )}
                                <DragDropContext
                                    onDragEnd={(result) => {
                                        const { source, destination } = result;
                                        if (!destination) return;
                                        if ( source.index === destination.index && source.droppableId === destination.droppableId ) return;

                                        setRespuestasPregunta( (prevResPre) => reorder(prevResPre, source.index, destination.index) );
                                    }}
                                >
                                    <Droppable droppableId="tasks">
                                        {(droppableProvided) => (
                                            <ol
                                                {...droppableProvided.droppableProps}
                                                ref={droppableProvided.innerRef}
                                                className="task-container"
                                            >
                                            {respuestasPregunta.map((r, index) => {


                                                let carpeta = alias_examen[ pk_materia ]
                                                let nombre = `${record.indice}-${carpeta}-${r.letra}.png`

                                                let src = `${DOMINIO_SERVIDOR}/img/examen/${carpeta}/${nombre}`

                                                if ( r.respuesta == ":imagen" ) {
                                                    return (
                                                        <Draggable key={r.pk_respuestas} draggableId={r.pk_respuestas?.toString()} index={index}>
                                                            {(draggableProvided) => (
                                                                <li
                                                                    {...draggableProvided.draggableProps}
                                                                    ref={draggableProvided.innerRef}
                                                                    {...draggableProvided.dragHandleProps}
                                                                    className="li-respuesta"
                                                                >
                                                                    <img src={ src } className='img-responsiva'/>
                                                                </li>
                                                            )}
                                                        </Draggable>
                                                    )
                                                } else {
                                                    return (
                                                        <Draggable key={r.pk_respuestas} draggableId={r.pk_respuestas?.toString()} index={index}>
                                                            {(draggableProvided) => (
                                                                <li
                                                                    {...draggableProvided.draggableProps}
                                                                    ref={draggableProvided.innerRef}
                                                                    {...draggableProvided.dragHandleProps}
                                                                    className="li-respuesta"
                                                                >
                                                                    {r.respuesta}
                                                                </li>
                                                            )}
                                                        </Draggable>
                                                    )
                                                }
                                            })}
                                                {droppableProvided.placeholder}
                                            </ol>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                                { mostrarBtn && (
                                    <Button type="primary" icon={<SyncOutlined />} size="middle" onClick={ reordenarRespuestas }>
                                        Actualizar orden
                                    </Button>
                                )}
                            </>
                        ),
                        expandedRowKeys: activeExpRow,
                        onExpand: (expanded, record) => {
                            const keys = [];
                            if (expanded) {
                              keys.push(record.pk_preguntas);
                            }
                            // console.log( record.respuestas );
                            setRespuestasPregunta( record.respuestas )
                            setActiveExpRow(keys);
                        }
                    }}
                />
            </div>

            {/* modal */}
            {/* <Modal
                visible = { visibleModal }
                title = "Copiar pregunta"
                onOk = { copiar }
                onCancel = { () => setVisibleModal( false ) }
                footer = {[
                    <Button key="back" onClick={ () => setVisibleModal( false ) }>
                        Cancelar
                    </Button>,
                    <Button key="submit" type="primary" loading={ loadingModal } onClick={ copiar }>
                        Copiar
                    </Button>
                ]}
            >
                <p>Seleccione una materia para copiar esta pregunta.</p>
                <Select defaultValue="0" style={{ width: 200 }} onChange={ (v, b) => setMateriaSeleccionada( b.value ) }>

                    <Option value="0" disabled>Selecciona una materia</Option>
                    { materias.map( e => (
                        <Option key={ e.pk_materia } value={ e.pk_materia }>{ e.materia }</Option>
                    ))}

                </Select>
            </Modal> */}

            <Toaster/>
        </>
    )
}

export default PreguntasMaterias
